export default __webpack_public_path__ + "static/exoqual-6479433c8555c18728e4a525de059f70.webp";